
  import { defineComponent, PropType } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import { getCurrentYear, getPreviousYear } from '@/common/utils/year';

  import type { TPresentationForm, TPresentationOption } from '../types/presentation';

  export default defineComponent({
    name: 'PresentationMainForm',
    components: { SelectMultiComponent, ButtonComponent, InputBlock },
    props: {
      countryId: {
        type: [Number, String] as PropType<TPresentationForm['countryId']>,
        default: null,
      },
      year: {
        type: Number as PropType<TPresentationForm['year']>,
        default: null,
      },
      countries: {
        type: Array as PropType<TPresentationOption[]>,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:countryId', 'update:year', 'submit'],
    computed: {
      countryModel: {
        get(): Exclude<TPresentationForm['countryId'], null> | undefined {
          return this.countryId ?? undefined;
        },
        set(value: TPresentationForm['countryId'] | undefined) {
          this.$emit('update:countryId', value ?? null);
        },
      },
      yearModel: {
        get(): Exclude<TPresentationForm['year'], null> | undefined {
          return this.year ?? undefined;
        },
        set(value: TPresentationForm['year'] | undefined) {
          this.$emit('update:year', value ?? null);
        },
      },
      countriesWithoutRussia(): TPresentationOption[] {
        return this.countries.filter((country) => country.id !== Constants.countryRussiaId);
      },
      yearOptions(): TPresentationOption[] {
        const current = getCurrentYear();
        const prev = getPreviousYear();
        return [
          { id: prev, text: prev },
          { id: current, text: current },
        ];
      },
    },
    methods: {
      onSubmit() {
        if (!this.validate()) return;
        this.$emit('submit');
      },
      validate(): boolean {
        const countrySelect = this.$refs.countrySelect as InstanceType<typeof SelectMultiComponent> | undefined;
        const yearSelect = this.$refs.yearSelect as InstanceType<typeof SelectMultiComponent> | undefined;
        countrySelect?.v$.$touch();
        yearSelect?.v$.$touch();
        return !countrySelect?.v$.$invalid && !yearSelect?.v$.$invalid;
      },
    },
  });
